export default __webpack_public_path__ + "static/media/gambero.b6fefbf7.avif";